import React from "react";
import { Download, ExternalLink, FileText } from "lucide-react";
import { downloadWorksheet } from "@/lib/api";

export const MANUSCRIPT_PDF = "/media/jt-hub-manuscript-paper.pdf";
export const TAB_PAPER_PDF = "/media/jt-hub-stave-tab-paper.pdf";
export const MANUSCRIPT_SITE = "https://www.blanksheetmusic.net/";

const PAPERS = [["treble", "Treble clef paper"], ["bass", "Bass clef paper"], ["grand", "Treble & bass clef paper"]];
const Pdf = ({ href, testId, children }) => (
  <a href={href} download target="_blank" rel="noreferrer" data-testid={testId}
    className="inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground transition-transform hover:scale-105">
    <Download size={13} /> {children}
  </a>
);

export const ManuscriptLinks = ({ testId = "manuscript", worksheet = 0, tabPaper = false, clefPapers = false, drumPaper = false }) => (
  <div className="mt-3 flex flex-wrap gap-2" data-testid={testId}>
    {clefPapers && PAPERS.map(([k, l]) => <Pdf key={k} href={`/media/jt-hub-${k}-paper.pdf`} testId={`${testId}-${k}-paper`}>{`Download free ${l} (PDF)`}</Pdf>)}
    {drumPaper && <Pdf href="/media/jt-hub-drum-paper.pdf" testId={`${testId}-drum-paper`}>Download free drum score paper (PDF)</Pdf>}
    {tabPaper && (
      <a href={TAB_PAPER_PDF} download target="_blank" rel="noreferrer" data-testid={`${testId}-tab-paper`}
        className="inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground transition-transform hover:scale-105">
        <Download size={13} /> Download free stave &amp; TAB paper (PDF)
      </a>
    )}
    {worksheet ? (
      <button type="button" onClick={() => downloadWorksheet(worksheet)} data-testid={`${testId}-worksheet`}
        className="inline-flex items-center gap-1.5 rounded-full border border-primary bg-primary/10 px-4 py-2 text-xs font-semibold text-primary transition-transform hover:scale-105">
        <FileText size={13} /> Open the Lesson {worksheet} worksheet (with answers)
        <span className="rounded-full bg-primary px-2 py-0.5 text-[10px] uppercase tracking-wider text-primary-foreground" data-testid={`${testId}-worksheet-badge`}>{worksheet === 1 ? "Free" : "Included with your course"}</span>
      </button>
    ) : null}
    {(worksheet === 3 || worksheet === 4) && (
      <button type="button" onClick={() => downloadWorksheet(worksheet, "diagrams")} data-testid={`${testId}-diagrams`}
        className="inline-flex items-center gap-1.5 rounded-full border border-primary bg-primary/10 px-4 py-2 text-xs font-semibold text-primary transition-transform hover:scale-105">
        <FileText size={13} /> {worksheet === 3 ? "Print the labelled note & time-signature diagrams" : "Print the notes & rests diagrams"}
        <span className="rounded-full bg-primary px-2 py-0.5 text-[10px] uppercase tracking-wider text-primary-foreground">Included with your course</span>
      </button>
    )}
    {worksheet === 4 && (
      <button type="button" onClick={() => downloadWorksheet(4, "cards")} data-testid={`${testId}-cards`}
        className="inline-flex items-center gap-1.5 rounded-full border border-primary bg-primary/10 px-4 py-2 text-xs font-semibold text-primary transition-transform hover:scale-105">
        <FileText size={13} /> Print the rhythm flash cards
        <span className="rounded-full bg-primary px-2 py-0.5 text-[10px] uppercase tracking-wider text-primary-foreground">Included with your course</span>
      </button>
    )}
    <a href={MANUSCRIPT_PDF} download target="_blank" rel="noreferrer" data-testid={`${testId}-download`}
      className="inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground transition-transform hover:scale-105">
      <Download size={13} /> Download free manuscript paper (PDF)
    </a>
    <a href={MANUSCRIPT_SITE} target="_blank" rel="noreferrer" data-testid={`${testId}-site`}
      className="inline-flex items-center gap-1.5 rounded-full border border-border px-4 py-2 text-xs font-semibold text-muted-foreground transition-colors hover:border-primary hover:text-primary">
      <ExternalLink size={13} /> More free manuscript paper
    </a>
  </div>
);
